import { watch, ref, computed } from '@vue/composition-api'
import useRequest from '@/compositions/useRequest'
import useReload from '@/compositions/useReload'

const STANDARD_ROUTES = [
  {
    title: 'Заказы',
    to: '/personal/orders',
    exact: false,
  },
]

const STANDARD_BOTTOM_ROUTES = [
  {
    title: 'Календарь аренды',
    to: '/personal/calendar',
  },
  {
    title: 'Переписка с диспетчером',
    to: '/personal/messages',
  },
  {
    title: 'Настройка профиля',
    to: '/personal/settings',
  },
]

const OWNERS_ROUTES = [
  // {
  //   title: 'Календарь аренды',
  //   to: '/personal/calendar',
  // },
  {
    title: 'Список техники',
    to: '/personal/instances',
  },
  {
    title: 'Карта техники',
    to: '/personal/instances/map',
  },
  {
    title: 'Водители',
    to: '/personal/drivers',
  },
  {
    title: 'Wialon',
    href: 'https://hosting.wialon.host/',
  },
]

const ROUTES_BY_ROLE = {
  user: [
    ...STANDARD_ROUTES,
    {
      title: 'Условия аренды',
      to: '/faq/usloviya-arendy',
    },
    ...STANDARD_BOTTOM_ROUTES,
  ],
  owner: [
    ...STANDARD_ROUTES,
    ...OWNERS_ROUTES,
    ...STANDARD_BOTTOM_ROUTES,
  ],
  dispatcher: [
    ...STANDARD_ROUTES,
    ...OWNERS_ROUTES,
    ...STANDARD_BOTTOM_ROUTES,
  ],
  admin: [
    ...STANDARD_ROUTES,
    ...OWNERS_ROUTES,
    ...STANDARD_BOTTOM_ROUTES,
  ],
}

export default ({
  metaInfo() {
    return {
      title: this.$route.name,
    }
  },
  data() {
    return {
      transitionName: '',
    }
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name) this.transitionName = 'fade-slide'
      else this.transitionName = ''
    },
  },
  setup(props, context) {
    const { $store } = context.root
    const links = ref([])
    const userRole = computed(() => $store.getters['auth/userRole'])

    const getRoutesByRole = (role) => {
      links.value = ROUTES_BY_ROLE[role]
    }

    const { makeRequest } = useRequest({
      context,
      request: () => $store.dispatch('data/getReviewOrderIds'),
    })
    if (userRole.value === 'user') {
      useReload({ cb: makeRequest, delay: 10000 })
    }

    watch(
      () => $store.getters['auth/userRole'],
      role => getRoutesByRole(role),
      { immediate: true },
    )

    return {
      links,
    }
  },
})
